export default __webpack_public_path__ + "static/media/services_dev_0.d65badc6.jpg";